import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Search Icon for Lyra Connect navigation (different from member-facing SearchIcon)
 */
export const ConnectSearchIcon: FunctionComponent<ConnectSearchIconProps> = ({ size = 24, fillColor }) => {
  const { colors } = useTheme()
  return (
    <Svg width={size} height={size} viewBox='0 0 40 40' fill='none'>
      <Path
        d='M15.0003 5C21.4502 5.00018 26.6663 10.2171 26.6663 16.667C26.6663 19.2835 25.8166 21.6839 24.3333 23.6338L34.5169 33.8164C35.1669 34.4664 35.1669 35.5336 34.5169 36.1836C34.1836 36.5003 33.7667 36.667 33.3333 36.667C32.9 36.667 32.4831 36.5003 32.1497 36.1836L21.9671 26C20.0172 27.4833 17.6169 28.3329 15.0003 28.333C8.55043 28.333 3.3335 23.1168 3.33333 16.667C3.33333 10.217 8.55032 5 15.0003 5ZM15.0003 8.33301C10.4003 8.33301 6.66634 12.067 6.66634 16.667C6.66651 21.2668 10.4004 25 15.0003 25C19.6001 24.9998 23.3332 21.2667 23.3333 16.667C23.3333 12.0671 19.6002 8.33318 15.0003 8.33301Z'
        fill={fillColor || colors.iconDefault}
      />
    </Svg>
  )
}

export type ConnectSearchIconProps = {
  size?: number
  fillColor?: string
}
